import * as types from './actionTypes';
import { beginAjaxCall } from './ajaxStatusActions';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ThunkResult } from '../models';
import { msalFetch } from '../components/auth/Auth-Utils';
import API from '../constants/apiEndpoints';
import { constants } from '../constants/constants';

export interface IEquipmentAlertResponse {
    installbaseIDs?: string[];
}

// The API might return an array directly or an object with installbaseIDs property
export type EquipmentAlertApiResponse = string[] | IEquipmentAlertResponse;

export function getEquipmentAlerts(
    facilityID: string,
    userID: string
): ThunkResult<any> {
    return (dispatch, getState) => {
        dispatch(beginAjaxCall());

        const axiosOptions: AxiosRequestConfig = {
            method: 'get',
            params: {
                facilityID,
                userID
            }
        };

        const url = API.GET.alert.equipment;

        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<EquipmentAlertApiResponse>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    // Handle both response formats: array directly or object with installbaseIDs
                    let installbaseIDs: string[] = [];

                    if (Array.isArray(data.data)) {
                        // API returned array directly
                        installbaseIDs = data.data;
                    } else if (data.data.installbaseIDs) {
                        // API returned object with installbaseIDs property
                        installbaseIDs = data.data.installbaseIDs;
                    }

                    const hasAlerts =
                        installbaseIDs && installbaseIDs.length > 0;

                    dispatch({
                        type: types.LOAD_EQUIPMENT_ALERTS_SUCCESS,
                        payload: {
                            installbaseIDs,
                            hasAlerts,
                            facilityID
                        }
                    });

                    return { installbaseIDs, hasAlerts };
                }
            })
            .catch((error: any) => {
                console.error('🚨 Equipment alerts API error:', error);
                dispatch({
                    type: types.LOAD_EQUIPMENT_ALERTS_FAILED,
                    error,
                    facilityID
                });
                constants.handleError(error, 'get equipment alerts');
                throw error;
            });
    };
}
